// extracted by mini-css-extract-plugin
export var container = "footer-module--container--19f18";
export var copyright = "footer-module--copyright--d4641";
export var footerNav = "footer-module--footerNav--b1741";
export var heading = "footer-module--heading--aafcb";
export var logo = "footer-module--logo--9d138";
export var socialLinks = "footer-module--socialLinks--e89f9";
export var wrapper = "footer-module--wrapper--fa68c";